import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class FamilyName extends PrimitiveValueObject<string> {
  /**
   * 作成
   * @param value 値
   * @returns 値
   */
  static create(value: string): FamilyName {
    if (!(value.length > 0)) {
      throw new Error('苗字が入力されていません');
    }
    return new FamilyName(value);
  }

  /** ラベル */
  static get label(): string {
    return '苗字 (保護者)';
  }

  /** プレースホルダー */
  static get placeholder(): string {
    return '山田';
  }

  /** タイプ */
  static get type() {
    return 'text';
  }

  /** キー */
  static get key() {
    return 'familyName';
  }

  /** バリデーションルール */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
    };
  }
}
